import { Controller } from "@hotwired/stimulus"
import {BrowserCodeReader, BrowserMultiFormatReader} from '@zxing/browser';
import {BarcodeFormat, DecodeHintType} from "@zxing/library";

export default class extends Controller {
  static targets = ["video"];

  connect() {

  }

  disconnect() {
    this.closeVideoStream();
  }

  startScan(event) {
    const frontCameraRegex = /front|Vorder|face|webcam|brio/i;
    const hints = new Map();
    const formats = [BarcodeFormat.QR_CODE, BarcodeFormat.ITF];
    hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);

    const codeReader = new BrowserMultiFormatReader(hints, {
      delayBetweenScanSuccess: 2000,
      delayBetweenScanAttempts: 600
    });

    navigator.mediaDevices.getUserMedia({video: true})
      .then((stream) => {
        stream.getTracks().forEach((track) => {
          track.stop();
        });

        navigator.mediaDevices.enumerateDevices()
          .then((devices) => {
            const videoDevices = devices.filter((device) => device.kind === 'videoinput');
            let frontCamera = videoDevices.filter(device => {
              return frontCameraRegex.test(device.label)
            })[0];

            if (!frontCamera && videoDevices.length > 0) {
              frontCamera = videoDevices[0];
            }

            if (frontCamera) {
              codeReader
                .decodeOnceFromVideoDevice(frontCamera.deviceId, 'login-video')
                .then((result) => {
                  this.onScanSuccess(result.text, result.format);
                })
                .catch(error => this.onScanFailure(error));

              setTimeout(this.closeVideoStream, 10000);
            } else {
              console.error('No camera found');
            }
          })
          .catch((err) => console.error('Error while accessing video devices:', err));
      }).catch((err) => {
      console.error("User denied camera access", err);
    });
  }

  onScanSuccess(barcodeText, barcodeFormat) {
    this.closeVideoStream();

    window.location.href = `/token_login?token=${barcodeText}&token_type=${barcodeFormat}`;
    //Turbo.visit(`token_login/${result}`);
  }

  onScanFailure(error) {
    console.warn(`QR Code scan error: ${error}`)
  }

  closeVideoStream(){
    let videoElement = document.getElementById('login-video');
    if (!videoElement) { return; }

    let stream = videoElement.srcObject;
    if (!stream) { return; }

    let tracks = stream.getTracks();
    if (!tracks) { return; }

    tracks.forEach(function (track) {
      track.stop();
    });

    videoElement.srcObject = null;
  }
}